<template>
<div>

  <div :class=boxClass>
    <vue-autosuggest
    v-model="query"
    ref="autosuggest"
    :suggestions="filteredOptions"
    :input-props="inputProps"
    :get-suggestion-value="getSuggestionValue"
    @input="onInputChange"
    @click="onInputClick"
    @keydown.enter.prevent="autoSuggestGo"
    @selected="selectSuggestion"
    >
      <template slot-scope="{suggestion}">
        {{ suggestion.item.s }}, {{ suggestion.item.t }}, {{ suggestion.item.p }}
      </template>
    </vue-autosuggest>
    <button :class=submitClass @click="autoSuggestGo" tabindex="-1">
      <svg class="icon"><use href="#search"></use></svg>
    </button>
  </div>

  <div :class=boxClass v-if="services.length">
    <select
    name="service"
    id="service"
    class="finder-select"
    v-model="filter['service']"
    @change="findClinicsByService"
    >
      <option value="">Filter by service</option>
      <option :value=service.slug v-for="service in services">{{ service.title }}</option>
    </select>
  </div>

  <template v-if="localClinics.length">
    <div style="margin-top: 40px;">
      <a href="#clinics" class="btn l_min l_white l_thick" data-breakmin="teen">View <span v-html="localClinics.length"></span> clinics as list</a>
      <button @click="mapShow()" class="btn l_min l_white l_thick" data-breakmax="teen">View on map</button>
    </div>
  </template>

  <template v-if="errors.length">
    <div style="margin-top: 40px;">
      <p v-for="error in errors"><strong v-html="error"></strong></p>
    </div>
  </template>


</div>
</template>

<script>
import getDistance from 'geolib/es/getDistance';
import { VueAutosuggest } from 'vue-autosuggest';
import EventBus from '../utils/event-bus';
import * as Cookie from '../cookies.js';
// import * as cities from '../cities.au.min.json';
// var suburbs = cities.default;
const queryString = require('query-string');

export default {
  name: "Finder",
  data() {
    return {

      clinics: [],
      filteredClinics: [],
      localClinics: [],
      bounds: [],

      query: '',
      selectedLocation: null,

      hasResults: false,

      isEmpty: false,

      isLoading: false,

      errors: [],

      suggestions: [],

      filteredSuggestions: [],

      inputProps: {
        placeholder: this.placeholder,
        class: this.inputClass
      },

      filter: {
        location: '',
        service: ''
      }

    };
  },
  props: {
    apikey: String,
    searchId: String,
    boxClass: {
      type: String,
      default: 'finder-field'
    },
    inputClass: {
      type: String,
      default: 'finder-input'
    },
    submitClass: {
      type: String,
      default: 'finder-submit'
    },
    placeholder: {
      type: String,
      default: 'Enter suburb or postcode'
    },
    services: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  components: {
    VueAutosuggest
  },
  computed: {

    filteredOptions() {
      if (this.suggestions) {
        var query = this.query.toLowerCase();
        if (query.indexOf(',') !== -1) query = query.substring(0, query.indexOf(','));
        var myArray = [
          {
            data: this.suggestions.filter(option => {
              if (query.length > 2) {
                var test = option.p.toString() + ' ' + option.s.toString();
                return test.toLowerCase().indexOf(query) > -1;
              } else {
                return false;
              }
            })
          }
        ];
        
        // sort results to put SA first
        var order = ['SA', 'VIC', 'NT', 'ACT', 'NSW', 'QLD', 'TAS', 'WA'];
        if (typeof myArray[0].data !== 'undefined' && myArray[0].data.length) {
          myArray[0].data = myArray[0].data.sort(function(a,b) {
            return order.indexOf( a.t ) - order.indexOf( b.t );
          });
        }
        
        return myArray;

      } else {
        return [];
      }
    }

  },
  methods: {

    findClinics() {

      this.errors = [];
      this.isLoading = true;
      EventBus.$emit('MAP_LOADING', this.searchId);

      this.filteredClinics = this.clinics;

      // filter by service
      if (this.filter['service'].length && this.filteredClinics.length) {

        this.filteredClinics = [];
        var searchClinics = this.clinics;

        // if (this.localClinics.length) {
        //   searchClinics = this.localClinics;
        // }

        searchClinics.forEach((clinic) => {

          var isMatched = false;

          clinic.services.forEach((service) => {

            if (service.slug == this.filter['service']) {
              isMatched = true;
            }

          });

          if (isMatched) {
            this.filteredClinics.push(clinic);
          }

        });

        searchClinics = this.filteredClinics;

      }

      // filter by location
      if (this.filter['location'].length && this.filteredClinics.length) {

        var address = this.filter['location'];

        if (this.boxClass == 'searchfield') {
          window.location.href = '/clinics/?s=' + encodeURI(address);
          return false;
        }

        var API_KEY = 'AIzaSyC0ORCOu-nI5W59T6Ka1tPlh0PsDY4Z2fQ';

        var localClinics = [];
        
        // var geocoder = new google.maps.Geocoder();
        // geocoder.geocode( { address: address }, function(results, status) 
        // {
        //   if (status == google.maps.GeocoderStatus.OK) 
        //   {
        //     console.log(results);
        //     // map.setCenter(results[0].geometry.location);//center the map over the result
        //     // //place a marker at the location
        //     // var marker = new google.maps.Marker(
        //     // {
        //     //     map: map,
        //     //     position: results[0].geometry.location
        //     // });
        //   } else {
        //     alert('Geocode was not successful for the following reason: ' + status);
        //  }
        // });
        
        

        var lat;
        var lng;
        // fetch("https://maps.googleapis.com/maps/api/geocode/json?region=au&address="+address+"&key="+API_KEY)
        //   .then(response => response.json())
        //   .then(data => {
            
        
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode( { address: address }, (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            
            this.errors.splice(0);

            // get lat and lng
            lat = results[0].geometry.location.lat();
            lng = results[0].geometry.location.lng();

            // update bounds with the searched location
            this.bounds = [{
              lat: lat,
              lng: lng
            }];

            // get clinics distances from search location
            this.filteredClinics.forEach(function(clinic, index, theArray) {
              var dist = getDistance(
                  { latitude: lat, longitude: lng },
                  { latitude: clinic.lat, longitude: clinic.lng }
              );
              dist = dist / 1000; // convert to kms
              theArray[index].distance = dist.toFixed(2);
            });

            // sort clinics by closest
            this.filteredClinics.sort(function(a, b) {
                return a.distance - b.distance;
            });

            // get clinics with 10km radius
            var loopIndex = 0;
            this.filteredClinics.forEach(function(clinic, index) {
              if (clinic.distance <= 10 || localClinics.length < 5) {
                localClinics.push(clinic);
              }
              loopIndex ++;
            });

            // push to state
            if (localClinics.length) {
              this.localClinics = localClinics;
            } else {
              this.localClinics = [];
            }

            this.bounds = this.bounds.concat(this.localClinics);

            this.isLoading = false;
            EventBus.$emit('MAP_NOTLOADING', this.searchId);

            this.showResults();

          } else {

            var errorMessage = 'The location you\'re searching for does not exist. Please try again.';
            this.errors.push(errorMessage);

            this.isLoading = false;
            EventBus.$emit('MAP_NOTLOADING', this.searchId);

          }
          
        });

      } else {

        // if we're not searching by location, then just go ahead and show the results
        this.localClinics = this.filteredClinics;
        this.bounds = this.filteredClinics;

        window.setTimeout(this.showResults, 200);

      }

      if (this.filter['service'].length || this.filter['location'].length) {
        EventBus.$emit('CLINIC_SEARCH');
      }

    },

    showResults() {

      this.isLoading = false;
      EventBus.$emit('MAP_NOTLOADING', this.searchId);

      // populate
      EventBus.$emit('MAP_POPULATE', this.searchId, this.localClinics, this.filteredClinics, this.bounds);
      if (this.localClinics.length) {
        this.hasResults = true;
        this.isEmpty = false;
      } else {
        this.hasResults = false;
        this.isEmpty = true;
      }

    },
    
    selectSuggestion(suggestion) {
      if (suggestion) {
        this.selectedLocation = suggestion;
      }
      this.findClinicsByLocation();
    },

    findClinicsByLocation() {
        
      // clear errors    
      this.errors.splice(0);
      
      // format query to check
      var queryArr = this.query.split(',');
      
      if (
          (typeof this.selectedLocation !== 'undefined' &&
          // typeof this.selectedLocation === 'object' &&
          // !Array.isArray(this.selectedLocation) &&
          this.selectedLocation !== null) ||
          (queryArr.length == 2 &&
          !isNaN(queryArr[2].trim()))
      ) {
        
        
        var locationToUse = this.selectedLocation;
        if (!locationToUse && queryArr.length == 2 &&
          !isNaN(queryArr[2].trim())) {
          locationToUse = this.query;
        }
      
        // update filter location
        this.filter['location'] = locationToUse;
        if (typeof locationToUse !== 'undefined' && typeof locationToUse == 'object' && locationToUse !== null) {
          if (typeof locationToUse.item !== 'undefined') {
            this.filter['location'] = this.getSuggestionValue(locationToUse);
          }
        }
        
        console.log(this.filter['location']);

        // save to cookie, 2 hours
        Cookie.create('bensonLocation', this.filter['location'], 0.0834);

        // run the search
        this.findClinics();
        
        
      } else {
        
        var errorMessage = 'Please select a valid suburb and try again.';
        this.errors.push(errorMessage);
        
      }

    },

    findClinicsByService() {

      EventBus.$emit('SERVICE_UPDATE', this.filter['service']);

      // save to cookie, 2 hours
      Cookie.create('bensonService', this.filter['service'], 0.0834);

      this.findClinics();

    },

    displayClinic(clinic) {

      EventBus.$emit('CLINIC_DISPLAY', this.searchId, clinic);

      return false;

    },

    onInputChange(text) {
      
    },

    onInputClick() {
      document.querySelector('.finder-input').select();
    },
    
    autoSuggestGo(event){
      const { listeners, setCurrentIndex, setChangeItem, getItemByIndex, internalValue, value, suggestions } = this.$refs.autosuggest

      if (value === internalValue && suggestions[0].data.length) {
        setCurrentIndex(0)
        setChangeItem(getItemByIndex(this.$refs.autosuggest.currentIndex), true)
        listeners.selected(true)
      }
      
      document.querySelector('.finder-input').blur();
      
    },

    getSuggestionValue(suggestion) {
      if (typeof suggestion !== 'undefined' && suggestion !== null) {
        return suggestion.item.s + ', ' + suggestion.item.t + ', ' + suggestion.item.p;
      } else {
        return '';
      }
    },

    mapShow() {

      EventBus.$emit('MAP_SHOW', this.searchId);

    }

  },
  mounted() {

    EventBus.$on('LOAD_CITIES', (cities) => {
      this.suggestions = cities;
    });

    // get clinics array
    if (typeof window.clinics !== 'undefined') {
      this.clinics = window.clinics;
      // console.log(this.clinics);
    }

    // check and read cookies
    if (Cookie.read('bensonLocation')) {
      var location = Cookie.read('bensonLocation').replace(/\W\,\./g, '');
      this.filter['location'] = location;
      this.selectedLocation = location;
      this.query = location;
    }
    if (Cookie.read('bensonService')) {
      var service = Cookie.read('bensonService').replace(/\W\,\./g, '');
      this.filter['service'] = service;
    }
    this.findClinics();

    if (typeof location !== 'undefined') {
      const parsed = queryString.parse(location.search);
      if (typeof parsed.s !== 'undefined') {
        if (parsed.s.length) {
          this.selectedLocation = parsed.s;
          this.query = parsed.s;
          this.findClinics();
        }
      }
    }

  }
};
</script>

<style scoped>
</style>